import { Note } from "@appretio/ui-kit";

/** Props for the context sync warning banner. */
interface ContextSyncWarningProps {
  /** List of field names that are out of sync. */
  changedFields: string[];
  /** Trailing action hint after the changed-field list. Defaults to the
   *  forecast wording; pass a page-specific hint where "reload before saving"
   *  doesn't fit (e.g. a client-side grid filter). */
  hint?: string;
}

/**
 * Warning banner shown when the current context selections
 * differ from what was last loaded. Reminds the user to re-Apply.
 */
export function ContextSyncWarning({
  changedFields,
  hint = "click Apply to reload before saving"
}: ContextSyncWarningProps) {
  if (changedFields.length === 0) return null;

  const fieldList = changedFields
    .map((field) => field.replace(/_/g, " "))
    .join(", ");

  return (
    <Note
      variant="warning"
      size="compact"
      text={`Context changed (${fieldList}) — ${hint}`}
    />
  );
}
